// ===== Shared type definitions =====

export interface User {
  id: number;
  // Optional: profile fetches (getUserById) deliberately omit telegram_id so it
  // never reaches other players. Present only on the logged-in user from auth.
  telegram_id?: number;
  username?: string;
  first_name?: string;
  last_name?: string;
  display_name?: string;
  tg_photo_url?: string | null;
  name_moderation_status?: 'pending' | 'approved' | 'rejected';
  pending_display_name?: string;
  is_admin?: boolean;
  is_guest?: boolean;
  invited_by?: number | null;
  email?: string | null;
  auth_uid?: string | null;
}

export interface Tournament {
  id: number;
  name: string;
  start_date: string;
  is_finished: boolean;
  orders_open: boolean;
  registration_open: boolean;
  image_url?: string;
  max_players: number;
  current_players: number;
  location?: string;
  description?: string;
  features?: string;
  dress_code?: string;
  tournament_type?: 'freezout' | 'deepstack' | 'phoenix' | 'classic' | 'bounty' | 'regular' | 'all_day';
  is_sold_out?: boolean;
  buy_in_price?: number;
}

export function getTournamentBg(type?: string): { url: string; position: string } {
  const map: Record<string, { url: string; position: string }> = {
    freezout: { url: '/tournament_freezout.PNG', position: 'right 30%' },
    deepstack: { url: '/tournament_Deepstack.PNG', position: 'right 40%' },
    phoenix: { url: '/tournament_phoenix.PNG', position: 'right 40%' },
    classic: { url: '/tournament_classic holdem.PNG', position: 'right 30%' },
    bounty: { url: '/tournament_bounty.PNG', position: 'right 70%' },
  };
  return map[type || ''] || map.freezout;
}

export interface UserRating {
  id: number;
  user_id: number;
  current_rating: number;
  monthly_rating: number;
  total_tournaments: number;
  total_points: number;
  total_knockouts: number;
  coins_balance: number;
  hucoin_balance?: number;
  equipped_bg: string | null;
  equipped_char: string | null;
  wins: number;
  final_tables: number;
  top_10_finishes: number;
  top_3_finishes: number;
  free_entries: number;
  xp: number;
  current_level: number;
}

export interface RatingPosition {
  position: number;
  rating: number;
  type?: string;
  user_id?: number;
  // Series-specific aggregates (set by getUserSeriesPosition; undefined for
  // the all-time/overall position from getUserRatingPosition).
  wins?: number;
  total_tournaments?: number;
  total_knockouts?: number;
}

export interface RegistrationStatus {
  status: 'registered' | 'waitlist' | 'not_registered';
  position?: number;
  checked_in?: boolean;
}

export interface PlayerRatingRow extends UserRating {
  first_name?: string;
  last_name?: string;
  username?: string;
  display_name?: string;
}

export interface TournamentResult {
  id: number;
  tournament_name: string;
  tournament_type: string;
  final_position: number;
  stage_reached: string;
  knockouts_count: number;
  points_earned: number;
  start_date: string;
}
